import { Carousel } from 'react-bootstrap';
import { Card, CardContent, Chip, Typography, Box } from "@mui/material";
import BASE_API_URL from '../../../apis/index';

export default function ProductCard({ product, images }) {
    return (
            <Card className="rounded-3 overflow-hidden shadow-none border h-100">
                {images.length > 0 ? (
                    <Carousel indicators={false} wrap={false}>
                        {images.map((img, idx) => (
                            <Carousel.Item key={idx}>
                                <img
                                    className="d-block w-100"
                                    src={`${BASE_API_URL}/uploads/user_prod_docs/${img}`}
                                    alt=""
                                    style={{
                                        height: "200px",
                                        objectFit: "cover",
                                    }}
                                />
                            </Carousel.Item>
                        ))}
                    </Carousel>
                ) : (
                    <Box
                        sx={{
                            height: 200,
                            background: "#f0f0f0",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        No Image
                    </Box>
                )}
                <CardContent>
                    <Typography variant="h6">
                        {product.product_name}
                    </Typography>
                    <Chip
                        className="mb-2 rounded-1"
                        label={<span className='text-white'> {product.category} </span>}
                        size="small"
                        color="secondary"
                    />
                    <Typography variant="body2">
                        Type: {product.product_type}
                    </Typography>

                    <Typography variant="body2" className='mb-4'>
                        Price: {product.pricing} {product.currency}
                    </Typography>
                    <a
                        className="CardLink"
                        href={`/admin/product-details?prodId=${product.id}`}
                    >
                        View Details
                    </a>
                </CardContent>
            </Card>
    )
}

